<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-8">
      <h4 class="font-medium mb-4">
        Insights Graph
      </h4>

    <!-- <div class="vx-col w-full"> -->
      <ApexCharts class="w-full" ref="campaignInsightsChart" type="line" :options="options" :series="chart" height="500px"></ApexCharts>
    <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {getTooltip} from '@/helpers/chartTooltip.js'
export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    const self = this
    return {
      cachedPayload: [],
      chart: [],
      options: {
        tooltip: {
          y: {
            formatter (value, index) {
              return getTooltip(value, index)
            }
          }
        },
        yaxis: {
          labels: {
            formatter (value) {
              return self.$options.filters.addComma(value)
            }
          }
        },
        xaxis: {
          type: 'category'
        },
        stroke: {
          curve: 'smooth'
        },
        legend: {
          show: true,
          position: 'top',
          fontSize: '14px',
          fontWeight: 'normal',
          fontFamily: 'Poppins',
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          itemMargin: {
            horizontal: 5,
            vertical: 10
          }
        }
      }
    }
  },
  watch: {

    chart () {
      this.$nextTick(() => {
        const eventLabel = this.pixelEventsKV[this.filters.pixelEvent] || 'Conversions'
        this.$refs['campaignInsightsChart'].toggleSeries('Impressions')
        this.$refs['campaignInsightsChart'].toggleSeries('Clicks')
        this.$refs['campaignInsightsChart'].toggleSeries('CTR')
        this.$refs['campaignInsightsChart'].toggleSeries('Avg. CPC')
        this.$refs['campaignInsightsChart'].toggleSeries('Video Views')
        this.$refs['campaignInsightsChart'].toggleSeries(eventLabel)
        this.$refs['campaignInsightsChart'].toggleSeries('CPA')
      })
    }
  },
  computed: {
    ...mapGetters({
      pixelEvents: 'campaign/pixelEvents'
    }),
    pixelEventsKV () {
      const result = {}

      this.pixelEvents.forEach(event => {
        result[event.id === 'total' ? 'Conversions' : event.id] = event.id === 'total' ? 'Conversions' : event.label
      })

      return result
    }
  },
  created () {
    this.fetchChartData()
  },
  methods: {
    async fetchChartData () {
      try {
        const response = await window.axios.get(`/campaigns/${this.$route.params.id}/insights/chart`, {
          params: {
            from_date: this.filters.dateRange.startDate,
            to_date: this.filters.dateRange.endDate,
            event: this.filters.pixelEvent,
            adsets: this.filters.adset ? [this.filters.adset] : []
          }
        })

        this.cachedPayload = response.data.payload

        this.chart = this.generateChartData(response.data.payload)


      } catch (error) {
        alert('Error processing the request')
      }
    },
    generateChartData (payload) {
      if (payload.length) {
        const result = payload.filter(i => i.type === 'primary')

        const event = this.filters.pixelEvent === 'total' ? 'Conversions' : this.filters.pixelEvent || 'Conversions'

        const selectedEvent = payload.filter(i => i.type === 'event').find(i => i.name === this.pixelEventsKV[event])

        if (selectedEvent) {
          result.push(selectedEvent)
        }

        const lastIndex = result.length - 1
        const secondLastIndex = result.length - 2

        // TODO fix this swap hangs page ADREV-2677
        return this.swap(result.map(i => {
          return {
            data: i.data,
            name: i.name
          }
        }), secondLastIndex, lastIndex)
      }

      return this.defaultChartData()
    },
    swap (arr, firstIndex, secondIndex) {
      const temp = arr[firstIndex]
      arr[firstIndex] = arr[secondIndex]
      arr[secondIndex] = temp
      return arr
    },
    defaultChartData () {

      const eventLabel = this.pixelEventsKV[this.filters.pixelEvent] || 'Events'
      return [
        {
          name: 'Impressions',
          data: []
        },
        {
          name: 'Clicks',
          data:  []
        },
        {
          name: 'CTR',
          data: []
        },
        {
          name: 'Avg. CPC',
          data: []
        },
        {
          name: 'Video Views',
          data: []
        },
        {
          name: 'Spent',
          data: []
        },
        {
          name: eventLabel,
          data: []
        },
        {
          name: 'CPA',
          data: []
        }
      ]
    }

  }
}
</script>

<style lang="scss" scoped>

/deep/ .apexcharts-toolbar {
  display: none;
}

/deep/ .apexcharts-legend-series {
  width: calc(50% - 20px);
}

/deep/ .apexcharts-legend {
  justify-content: space-between !important;
}

/deep/ .apexcharts-canvas {
  width: 100% !important;
}

@media (min-width: 768px) {
  /deep/ .apexcharts-legend-series {
    width: auto;
  }
}

</style>
